export * from './new-precio-financiera.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/financiera/new-precio-financiera/index.ts